import { render, staticRenderFns } from "./IndicatorManagementPage.vue?vue&type=template&id=6145f903&scoped=true&"
import script from "./IndicatorManagementPage.vue?vue&type=script&lang=js&"
export * from "./IndicatorManagementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6145f903",
  null
  
)

export default component.exports